import { colorsPalettes } from "@similarweb/styles";

export enum ETabs {
    PhraseMatch,
    RelatedKeywords,
}

const chartGradientParams = {
    stop1Color: colorsPalettes.blue[100],
    stop2Color: colorsPalettes.blue[100],
    fillColor: colorsPalettes.blue[400],
};

export const YOUTUBE_KEYWORD_GENERATOR_ENDPOINT = `/api/KeywordGenerator/youtube/suggest`;
export const YOUTUBE_KEYWORD_GENERATOR_EXCEL_ENDPOINT = `/api/KeywordGenerator/youtube/suggest/excel`;
